<template>
  <div class="page"
       v-bind:class="{
          'page--overlay' : initialData.overlayMenu,
          'page--auth-overlay' : isActiveOverlayLogin
       }">

    <Header></Header>

    <div class="instr-wrap">

      <div class="instr-section">
        <div class="instr-l-title">
          РУКОВОДСТВО ПО ЭКСПЛУАТАЦИИ<br>
          SCHER-KHAN X-TAG
        </div>
        <div class="instr-m-title">
          Установка элемента питания метки
        </div>
        <div class="instr-clarification">
          Перед эксплуатацией метки необходимо задействовать установленный в ней элемент питания.
        </div>
        <div class="instr-s-title">
          Для задействования элемента питания метки выполните следующие действия:
        </div>
        <div class="instr-list">
          <div class="instr-list_item">
            <div class="instr-list_img instr-list_img__big">
              <img src="@/assets/img/instructions/xtag/battary.jpg">
            </div>
            <div class="instr-list_params">
              <div class="instr-list_text">
                1. Откройте крышку батарейного отсека, расположенную на тыльной стороне метки
              </div>
              <div class="instr-list_text">
                2. Извлеките из-под установленного элемента питания изолирующую прокладку
              </div>
              <div class="instr-list_text">
                3. Закройте крышку батарейного отсека. Метка готова к работе
              </div>
            </div>
          </div>
        </div>

        <div class="instr-hr">
        </div>

        <div class="instr-l-title">
          НАЗНАЧЕНИЕ МЕТКИ
        </div>
        <div class="instr-s-title">
          Метка SCHER-KHAN X-Tag предназначена для:
        </div>
        <div class="instr-list">
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                1.
              </div>
              Управления системой SCHER-KHAN MOBICAR 3 Compact, MOBICAR 3 Light, X1, X2, X2M, X4, X6, T1,
              T2. Осуществления постановки на охрану, снятия с охраны, дистанционного запуска двигателя с
              помощью кнопки
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                2.
              </div>
              Автоматического включения режима охраны и автоматического выключения режима охраны
              при удалении и приближении к автомобилю (функции системы «Автопостановка» и
              «Автоснятие»)
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                3.
              </div>
              Обеспечения дополнительного уровня защиты автомобиля (функция системы «Иммобилайзер»)
            </div>
          </div>
        </div>
        <div class="instr-p">
          Обмен информацией между меткой и системой возможен по беспроводному соединению Bluetooth
          (только в непосредственной близости от автомобиля).
        </div>

        <div class="instr-hr">
        </div>

        <div class="instr-l-title">
          ФУНКЦИИ КНОПКИ МЕТКИ
        </div>
        <div class="instr-list_img instr-list_img__center">
          <img src="@/assets/img/instructions/xtag/button-tag.jpg">
        </div>
        <div class="instr-p">
          Ниже приведена таблица команд метки. Каждой команде соответствует номер, в котором количество десятков
          равно количеству длинных нажатий на кнопку, а количество единиц - количеству коротких нажатий.<br><br>
          <span class="instr_pressing-icon"></span> - длинное нажатие (более 2 секунд) до двойного сигнала светодиода<br>
          <span class="instr_pressing-icon instr_pressing-icon__light"></span> - короткое нажатие до одиночного сигнала светодиода
        </div>
        <div class="instr-list_item">
          <div>
            <table border="1px solid black" class="instr-table">
              <thead>
                <tr>
                  <th>
                    Номер команды
                  </th>
                  <th>
                    Функция метки
                  </th>
                  <th>
                    Необходимые условия
                  </th>
                  <th>
                    Длительность нажатия
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="6">
                    01
                  </td>
                  <td>
                    Включение охраны
                  </td>
                  <td>
                    Охрана выключена
                  </td>
                  <td rowspan="6">
                    <span class="instr_pressing-icon instr_pressing-icon__light"></span>
                  </td>
                </tr>
                <tr>
                  <td>
                    Выключение охраны
                  </td>
                  <td>
                    Охрана включена
                  </td>
                </tr>
                <tr>
                  <td>
                    Выключение режима тревоги
                  </td>
                  <td>
                    Режим тревоги включен
                  </td>
                </tr>
                <tr>
                  <td>
                    Включение охраны с работающим двигателем, запущенным вручную
                  </td>
                  <td>
                    Включен стояночный тормоз
                  </td>
                </tr>
                <tr>
                  <td>
                    Включение охраны с работающим двигателем, в автоматическом режиме
                  </td>
                  <td>
                    Двигатель работает в автоматическом режиме (поддержка зажигания, парковка с работающим двигателем, автозапуск, турботаймер)
                  </td>
                </tr>
                <tr>
                  <td>
                    Выключение охраны с работающим двигателем
                  </td>
                  <td>
                    Охрана с работающим двигателем включена
                  </td>
                </tr>


                <tr>
                  <td rowspan="6">
                    20
                  </td>
                  <td>
                    Автоматический запуск
                    двигателя
                  </td>
                  <td>
                    Двигатель выключен. <br>
                    Подготовка к запуску для МКПП выполнена
                  </td>
                  <td rowspan="6">
                    <span class="instr_pressing-icon"></span>
                    <span class="instr_pressing-icon"></span>
                  </td>
                </tr>
                <tr>
                  <td>Завершение автозапуска</td>
                  <td>Автозапуск выполняется</td>
                </tr>
                <tr>
                  <td>Включение парковки с работающим двигателем</td>
                  <td>Двигатель включен вручную, включен стояночный тормоз</td>
                </tr>
                <tr>
                  <td>Выключение парковки с работающим двигателем</td>
                  <td>Включена парковка с работающим двигателем</td>
                </tr>
                <tr>
                  <td>Выключение режима «Турботаймер»</td>
                  <td>Режим «Турботаймер» включен</td>
                </tr>
                <tr>
                  <td>Выключение подготовки к запуску</td>
                  <td>Подготовка к запуску выполняется</td>
                </tr>
                <tr>
                  <td>
                    13
                  </td>
                  <td>
                    Регистрация метки в памяти
                    системы
                  </td>
                  <td>
                    Охрана выключена, система переведена в режим регистрации меток
                  </td>
                  <td>
                    <span class="instr_pressing-icon"></span>
                    <span class="instr_pressing-icon instr_pressing-icon__light"></span>
                    <span class="instr_pressing-icon instr_pressing-icon__light"></span>
                    <span class="instr_pressing-icon instr_pressing-icon__light"></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="instr-hr">
        </div>

        <div class="instr-l-title">
          РЕГИСТРАЦИЯ МЕТКИ В ПАМЯТИ СИСТЕМЫ
        </div>
        <div class="instr-clarification">
          Система работает только с теми метками, которые зарегистрированы в её памяти.
        </div>
        <div class="instr-clarification">
          Система может работать одновременно с 2 метками, добавленными в рамках одной процедуры сопряжения. При
          повторном сопряжении с новыми метками все ранее сопряжённые метки удаляются из памяти системы.
        </div>
        <div class="instr-s-title">
          Для регистрации метки выполните следующие действия:
        </div>

        <div class="instr-list">
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                1.
              </div>
              Убедитесь, что охрана выключена
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                2.
              </div>
              Нажмите кнопку на антенном модуле (кнопку-индикатор) до подачи звукового сигнала
              (удерживайте не менее 2-х сек.)
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                3.
              </div>
              Три раза коротко нажмите кнопку на антенном модуле (кнопку-индикатор), в подтверждение
              каждого нажатия, после того как кнопка отпущена антенный модуль (основной блок) подаст
              звуковой сигнал
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                4.
              </div>
              Прозвучит 1 короткий звуковой сигнал антенного модуля (основного блока). Индикатор на
              антенном модуле (кнопка-индикатор) начнет быстро мигать
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                5.
              </div>
              Введите PIN-код. Для этого нажмите кнопку на антенном модуле (кнопку-индикатор) количество
              раз, соответствующее первой цифре PIN-кода, и ожидайте звукового сигнала. Через 5 секунд
              антенный модуль (основной блок) звуковым сигналом оповестит о готовности к вводу
              следующей цифры. Введите таким же образом оставшиеся цифры PIN-кода
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                6.
              </div>
              Прозвучит 1 короткий звуковой сигнал антенного модуля (основного блока). Индикатор на
              антенном модуле (кнопка-индикатор) начнет быстро мигать
            </div>
          </div>
          <div class="instr-list_param instr-list_param__attention"
               style="margin-top: -20px">
            Если PIN-код введён неверно, индикатор не загорится, а антенный модуль (основной блок) подаст 3
            звуковых сигнала. Необходимо повторить действия, начиная с пункта 2.
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                7.
              </div>
              Вытащите батарейку метки на 5 сек. и установите ее вновь.<br>
              Нажмите длительно (удерживайте не менее 2-х сек.) кнопку на регистрируемой метке. Затем три
              раза коротко нажмите кнопку на регистрируемой метке. Индикатор на метке начнёт
              попеременно мигать синим и красным цветом. В подтверждение успешной регистрации метки
              прозвучит 1 короткий звуковой сигнал антенного модуля (основного блока)
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                8.
              </div>
              Если регистрируются две метки, то после регистрации первой, аналогично переведите вторую метку в режим сопряжения как указано в пункте <b>7</b>.
            </div>
          </div>
        </div>
        <div class="instr-clarification">
          Заводской PIN-код указан на тыльной стороне карты пользователя, которая входит в комплект
          поставки системы
        </div>

        <div class="instr-hr">
        </div>

        <div class="instr-l-title">
          ОБНОВЛЕНИЕ ПРОГРАММНОГО ОБЕСПЕЧЕНИЯ МЕТКИ
        </div>
        <div class="instr-s-title">
          Для обновления программного обеспечения метки переведите ее в режим обновления:
        </div>
        <div class="instr-list">
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                1.
              </div>
              Откройте крышку батарейного отсека, расположенную на тыльной стороне метки.
              Извлеките  элемент питания из метки, нажмите и удерживайте кнопку метки
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                2.
              </div>
              Установите элемент питания обратно, удерживая при этом нажатой кнопку. Отпустите кнопку.
              Закройте крышку батарейного отсека. Метка находится в режиме обновления
            </div>
          </div>
        </div>

        <div class="instr-s-title">
          Запустите процедуру в приложение SK AUTO:
        </div>
        <div class="instr-list">
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                1.
              </div>
              В левом верхнем углу экрана запустите “Меню подключений и выбора систем” , нажав “≡”
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                2.
              </div>
              Запустите “Меню добавления систем”
              <div class="instr-list_item">
                <div class="instr-list_text">
                  <div class="instr-list_numeric">
                    2.1.
                  </div>
                  В IOS нажмите “+” справа вверху
                </div>
              </div>
              <div class="instr-list_item">
                <div class="instr-list_text">
                  <div class="instr-list_numeric">
                    2.2.
                  </div>
                  В Android нажмите “+” справа внизу
                </div>
              </div>
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                3.
              </div>
              В открывшемся меню выберите “Добавить по BLUETOOTH”
              <div class="instr-list_item">
                <div class="instr-list_text">
                  <div class="instr-list_numeric">
                    3.1.
                  </div>
                  В IOS откроется страницы с информацией о найденной метке в режиме обновления,  нажмите “Установить обновление”
                </div>
              </div>
              <div class="instr-list_item">
                <div class="instr-list_text">
                  <div class="instr-list_numeric">
                    3.2.
                  </div>
                  В Android обновление запустится автоматически, на экране отобразится сообщение о начале
                </div>
              </div>
            </div>
          </div>
          <div class="instr-list_item">
            <div class="instr-list_text">
              <div class="instr-list_numeric">
                4.
              </div>
              Дождитесь окончания обновления
              <div class="instr-list_item">
                <div class="instr-list_text">
                  <div class="instr-list_numeric">
                    4.1.
                  </div>
                  В IOS информация о состоянии обновления отображается на экране в виде круглого статус-бара
                </div>
              </div>
              <div class="instr-list_item">
                <div class="instr-list_text">
                  <div class="instr-list_numeric">
                    4.2.
                  </div>
                  В Android увидеть состояние обновления можно в верхней шторке телефона
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="instr-clarification">
          В момент обновления устанавливается последняя доступная прошивка.
        </div>
        <div class="instr-clarification">
          После обновления метка готова к работе
        </div>

        <div class="instr-hr">
        </div>

        <div class="instr-l-title">
          ТЕХНИЧЕСКИЕ ХАРАКТЕРИСТИКИ
        </div>
        <table class="instr-table">
          <tr>
            <td rowspan="2">
              Параметр
            </td>
            <td colspan="2">
              Значение
            </td>
          </tr>
          <tr>
            <td>
              Мин.
            </td>
            <td>
              Макс.
            </td>
          </tr>
          <tr>
            <td>Метка</td>
            <td colspan="2"></td>
          </tr>
          <tr>
            <td>Несущая частота радиоканала (ГГц)</td>
            <td colspan="2">2,4</td>
          </tr>
          <tr>
            <td>Протокол связи</td>
            <td colspan="2">Bluetooth 5.0</td>
          </tr>
          <tr>
            <td>Элемент питания метки</td>
            <td colspan="2">3 В (батарея CR2032)</td>
          </tr>
          <tr>
            <td>Диапазон рабочих температур (°С)</td>
            <td>0</td>
            <td>+40</td>
          </tr>
          <tr>
            <td>Исполнение корпуса</td>
            <td colspan="2">IP-54</td>
          </tr>
        </table>

        <div style="height: 30px">
        </div>

      </div>

      <Footer></Footer>
    </div>

  </div>
</template>

<script>
  import Header from '@/components/Initial/Header.vue'
  import Footer from '@/components/Initial/Footer.vue'

  export default {
    data(){
      return{
        m3lCall : [
          {
            index : '1',
            name : 'Поставить на охрану'
          },
          {
            index : '01',
            name : 'Закрыть центральный замок'
          },
          {
            index : '2',
            name : 'Снять с охраны',
            desc : 'требуется PIN-код'
          },
          {
            index : '02',
            name : 'Открыть центральный замок'
          },
          {
            index : '3',
            name : 'Завести двигатель'
          },
          {
            index : '03',
            name : 'Выключить двигатель'
          },
          {
            index : '4',
            name : 'Отпереть багажник'
          },
          {
            index : '04',
            name : 'Запереть багажник'
          },
          {
            index : '5',
            name : 'Включить подогреватель'
          },
          {
            index : '05',
            name : 'Выключить подогреватель'
          },
          {
            index : '6',
            name : 'Перейти в сервисный режим',
            desc : 'требуется PIN-код'
          },
          {
            index : '06',
            name : 'Выключить сервисный режим',
          },
          {
            index : '7',
            name : 'Разрешить поездку',
            desc : 'требуется PIN-код'
          },
          {
            index : '8',
            name : 'Включить сигнал',
          },
          {
            index : '#',
            name : 'Завершить вызов',
          },
        ]
      }
    },
    mounted() {
      if( this.initialPage ){
        this.$store.dispatch('toggleInitialPage');
      }
    },
    computed : {
      initialPage() {
        return this.$store.state.initialPage;
      },
      initialData : function (){
        return this.$store.state.initial
      },
      isActiveOverlayLogin(){
        return this.$store.state.panels.login.status
      },
    },
    components: {
      Header,
      Footer
    },
  }
</script>